export function liveTimeLeftStatus(opts: {
  isShotClock: boolean;
  lotNum?: string | number | null;
}): string {
  if (opts.isShotClock && opts.lotNum != null && String(opts.lotNum).length > 0) {
    return `Lot ${opts.lotNum} Time Left:`;
  }
  return 'Time Left:';
}

export function formatCountdownMs(ms: number): string {
  const clamped = Math.max(0, Number.isFinite(ms) ? ms : 0);
  const totalSeconds = Math.floor(clamped / 1000);
  const minutes = Math.floor(totalSeconds / 60) % 60;
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export function isShotClockLotClosing(opts: {
  isShotClock: boolean;
  remainingMs: number;
}): boolean {
  return !!(opts.isShotClock && Number.isFinite(opts.remainingMs) && opts.remainingMs <= 0);
}

export function formatLotClockDisplay(ms: number, opts?: { isShotClock?: boolean }): string {
  if (isShotClockLotClosing({ isShotClock: !!(opts && opts.isShotClock), remainingMs: ms })) {
    return 'Lot Closing';
  }
  return formatCountdownMs(ms);
}

export function adminAuctionRemainingStatus(): string {
  return 'Time remaining in auction:';
}

export function showAdminDualTimer(opts: {
  isShotClock: boolean;
  isLive: boolean;
}): boolean {
  return !!(opts.isShotClock && opts.isLive);
}
